export function handleCardCollapse(selector) {
	if (typeof selector === 'object') {
		var $cont = selector.find('[card-collapse]');
	} else {
		var $cont = $(selector + ' [card-collapse]');
	}

	$cont.each(function (idx) {
		let $el = $(this);
		$el.on('click', function (event) {
			event.preventDefault()
			$el.toggleClass('collapsed');

			$el.closest('.k-card').find('.k-card-body').toggleClass('hidden');
		});
	});
}